import { HasFiscalPrinter } from '@pos/app/scripts/services/has-fiscal-printer';
import { PosState } from '@pos/app/scripts/services/pos-state';

/*
 * Service isFiscalReturn—returns true when on fiscal printer, and in return.
 */
angular
  .module('posApp')
  .factory(
    'isFiscalReturn',
    (posState: PosState, hasFiscalPrinter: HasFiscalPrinter) => {
      const isFiscalReturn = () => {
        if (hasFiscalPrinter() && posState.returnTransaction) {
          return true;
        }

        return false;
      };

      return isFiscalReturn;
    },
  );
